import { Button } from 'design-system';
import { FormattedMessage } from 'react-intl';
import styles from './LoginForm.module.css';

const VerificationMessage = ({
  onResend,
  messageId = 'verification_message',
  buttonId = 'resend_email',
  buttonProps = {},
}) => {
  return (
    <div>
      <div className={styles['message']}>
        <FormattedMessage id={messageId} defaultMessage={messageId} />
      </div>
      {onResend && (
        <div className={styles['btn-container'] ?? styles['for-btn-container']}>
          <Button type="link" onClick={onResend} {...buttonProps}>
            <FormattedMessage id={buttonId} defaultMessage={buttonId} />
          </Button>
        </div>
      )}
    </div>
  );
};

export default VerificationMessage;
